import { createLayout, type Layout } from '@atlassian/jira-route-layout';

export const userBoardLayout: Layout = createLayout();
